module.exports = __webpack_public_path__ + "50c5c07415f429d94c0ac98d3ea7a953.png";